const PAUSED = "ARTIFACT_PUBLICATION_STATE_PAUSED";
const TENANT_TARGET = "ARTIFACT_AUDIENCE_KIND_TENANT_TARGET";
const HOLDABLE_STATES = new Set([
    "ARTIFACT_PUBLICATION_STATE_COMPLETED",
    PAUSED,
    "ARTIFACT_PUBLICATION_STATE_PENDING",
    "ARTIFACT_PUBLICATION_STATE_ROLLING",
]);
const TENANT_AUDIENCES = new Set([
    "ARTIFACT_AUDIENCE_KIND_TENANT_MAIN",
    "ARTIFACT_AUDIENCE_KIND_TENANT_PREVIEW",
    TENANT_TARGET,
]);

export function hasHoldableState(row) {
    return HOLDABLE_STATES.has(row.publicationState);
}

export function canControlDelivery(row) {
    return hasHoldableState(row) && TENANT_AUDIENCES.has(row.audienceKind) && !row.systemEnforced;
}

export function deliveryStopped(row) {
    return Boolean(row.held) || row.publicationState === PAUSED;
}

export function deliveryControlCommand(value) {
    if (!Object.hasOwn(value, "held")) return "resumePublication";
    return Object.hasOwn(value, "trackId") ? "setTrackHold" : "setTenantHold";
}

export function deliveryControlCommands(row, resume = deliveryStopped(row)) {
    if (!canControlDelivery(row)) return [];
    const { publicationId, trackId } = row;
    // Resume an existing pause while the hold still blocks delivery. If either
    // request fails, refreshed state lets the next attempt finish the remainder.
    const commands = resume && row.publicationState === PAUSED ? [{ publicationId }] : [];
    if (!resume || row.held) commands.push({
        held: !resume,
        publicationId,
        reason: resume ? "Tenant resumed release rollout" : "Tenant held release rollout",
        ...(row.audienceKind === TENANT_TARGET ? {} : { trackId }),
    });
    return commands;
}
